import * as React from 'react';
import cn from 'classnames';
import { useResponsive } from 'client/hooks';
import headerLogo from 'src/routes/client/assets/header-logo-2025-desk.jpg';
import headerLogoMob from 'src/routes/client/assets/header-logo-2025-mob.jpg';
import Socialls from '../Socialls';
import Accessibility from '../Accessibility';
import css from './Header.module.scss';

interface Props {
  className?: '';
}

const Header: React.FC<Props> = (props) => {
  const { className = '' } = props;
  const [isMobile] = useResponsive('MOBILE');

  return (
    <header className={cn(css.header, className)}>
      {!isMobile && (
        <div className={css.headerLogoDesk}>
          <img src={headerLogo} alt="logo" />
        </div>
      )}
      {isMobile && (
        <div className={css.headerLogoMob}>
          <img src={headerLogoMob} alt="logo" />
        </div>
      )}
      <div className={css.sociallsWrapper}>
        <Socialls />
        <Accessibility />
      </div>
    </header>
  );
};

export default Header;
